import React, { useState, useEffect } from 'react';
import { homeApi } from '../api/home';
import './Test.css';

const Test = () => {
  const [status, setStatus] = useState('初始化中...');
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    testApiConnection();
  }, []);

  const testApiConnection = async () => {
    try {
      setStatus('正在连接API...');
      
      // 测试首页数据接口
      const result = await homeApi.getGoodslist({ type: 1 });
      
      console.log('API响应:', result);
      
      if (result.code === 200 || result.code === 1) {
        setStatus('✅ API连接成功！');
        setApiData({
          message: '数据获取成功',
          code: result.code,
          dataKeys: result.data ? Object.keys(result.data) : [],
          hasData: !!result.data
        });
      } else {
        setStatus('❌ API返回错误');
        setError(result.msg || '未知错误');
      }
    } catch (err) {
      console.error('API连接失败:', err);
      setStatus('❌ API连接失败');
      setError(err.message || '网络错误');
    }
  };

  const testSpecificEndpoint = async (endpointName, apiCall) => {
    try {
      setStatus(`正在测试 ${endpointName}...`);
      const result = await apiCall();
      
      if (result.code === 200 || result.code === 1) {
        setStatus(`✅ ${endpointName} 测试成功`);
        setApiData({
          endpoint: endpointName,
          success: true,
          data: result.data
        });
      } else {
        setStatus(`❌ ${endpointName} 测试失败`);
        setError(result.msg);
      }
    } catch (err) {
      setStatus(`❌ ${endpointName} 测试失败`);
      setError(err.message);
    }
  };

  return (
    <div className="test-container">
      <div className="test-header">
        <h1>Lynx API 连接测试</h1>
        <div className={`status ${status.includes('✅') ? 'success' : status.includes('❌') ? 'error' : 'loading'}`}>
          {status}
        </div>
      </div>

      <div className="test-section">
        <h2>API配置</h2>
        <div className="config-item">
          <span className="label">API地址:</span>
          <span className="value">{process.env.REACT_APP_API_URL || 'http://localhost:8000'}</span>
        </div>
        <div className="config-item">
          <span className="label">前端地址:</span>
          <span className="value">{window.location.origin}</span>
        </div>
      </div>

      <div className="test-section">
        <h2>测试按钮</h2>
        <div className="button-group">
          <button onClick={() => testApiConnection()}>
            🔄 测试首页API
          </button>
          <button onClick={() => testSpecificEndpoint('推荐资料', () => homeApi.getRecommendList({ limit: 5 }))}>
            📚 测试推荐资料
          </button>
          <button onClick={() => testSpecificEndpoint('轮播图', () => homeApi.getBanner())}>
            🖼️ 测试轮播图
          </button>
        </div>
      </div>

      {error && (
        <div className="error-section">
          <h2>错误信息</h2>
          <div className="error-message">{error}</div>
        </div>
      )}

      {apiData && (
        <div className="data-section">
          <h2>API响应数据</h2>
          <pre className="data-display">
            {JSON.stringify(apiData, null, 2)}
          </pre>
        </div>
      )}

      <div className="info-section">
        <h2>使用说明</h2>
        <ul>
          <li>✅ PHP后端运行在 <strong>http://localhost:8000</strong></li>
          <li>✅ React前端运行在 <strong>http://localhost:3000</strong></li>
          <li>✅ CORS跨域已配置</li>
          <li>✅ API接口兼容现有ThinkPHP后端</li>
        </ul>
      </div>
    </div>
  );
};

export default Test;